<template>
  <div
    style="position: relative"
    class="d-flex flex-wrap gap-2 align-items-center"
  >
    <div class="d-flex align-items-center">
      <b-form-select
        class="flex-1"
        :modelValue="filterItemService?.value?.operator || 'eq'"
        @update:modelValue="updateOperator"
        :options="options"
        size="sm"
        style="width: auto"
      ></b-form-select>
    </div>
    <div v-if="operator !== 'isnull' && operator !== 'isnotnull'">
      <div
        class="d-flex"
        v-if="operator === 'between'"
      >
        <b-form-input
          type="number"
          size="sm"
          ref="filterItemFormInput"
          :modelValue="!!modelValue ? modelValue[0] : null"
          @update:modelValue="(_val) => changeModelValue(0, _val)"
        />
        <span class="ml-1 mr-1">~</span>
        <b-form-input
          type="number"
          size="sm"
          :modelValue="!!modelValue ? modelValue[1] : null"
          @update:modelValue="(_val) => changeModelValue(1, _val)"
        />
      </div>
      <div v-else>
        <b-form-input
          type="number"
          size="sm"
          ref="filterItemFormInput"
          :modelValue="modelValue"
          @update:modelValue="change"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { FilterItemService } from '../../../FilterItemService'
import { FILTER_OPERATOR_FOR_NUMBER } from '../../../FilterRuleService'

export default {
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      operator: null,
    }
  },
  computed: {
    filterItemService(): FilterItemService<any> {
      // @ts-ignore
      return (
        // @ts-ignore
        this.$provides?.filterItemService?.value || this.$provides?.filterObject?.value
      )
    },
    options() {
      // { value: xxxx'', text: 'xxxxx' }のような形で返す
      return Object.keys(FILTER_OPERATOR_FOR_NUMBER).map((operator) => {
        return {
          value: operator,
          text: FILTER_OPERATOR_FOR_NUMBER[operator],
        }
      })
    },
  },
  watch: {
    'filterItemService.isFocus'(val) {
      if (val && this.$refs.filterItemFormInput) {
        // @ts-ignore
        this.$refs.filterItemFormInput?.focus?.()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.operator = this.filterItemService?.value?.operator
      if (!this.operator) {
        this.operator = this.options.length > 0 ? this.options[0].value : null
      }
      setTimeout(() => {
        // @ts-ignore
        this.$refs.filterItemFormInput?.focus?.()
      }, 100)
    })
  },
  methods: {
    change(value) {
      this.$emit('update:modelValue', {
        value,
        operator: this.operator,
      })
    },
    updateOperator(value) {
      this.operator = value
      if (this.operator == 'between') {
        this.$emit('update:modelValue', {
          value: Array.isArray(this.modelValue)
            ? this.modelValue
            : [this.modelValue, null],
          operator: this.operator,
        })
      } else if (this.operator === 'isnull' || this.operator === 'isnotnull') {
        this.$emit('update:modelValue', {
          value: null,
          operator: this.operator,
        })
      } else {
        this.$emit('update:modelValue', {
          value: Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue,
          operator: this.operator,
        })
      }
    },
    changeModelValue(index, value) {
      const newValue = [...this.modelValue]
      newValue[index] = value
      this.$emit('update:modelValue', {
        value: newValue,
        operator: this.operator,
      })
    },
    onDismissDropDown() {
      this.$emit('onDismissDropdown')
    },
  },
}
</script>
